require('./sources/styles/ngafx.css');
require('./sources/scripts/ngafx.js');
module.exports = 'ngAfx';


/*****************
 ** WEBPACK FOOTER
 ** ./~/angular-animation-fx/index.js
 ** module id = 659
 ** module chunks = 1
 **/